module.exports = __webpack_public_path__ + "static/img/bg.f838deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/bg.png
// module id = 4jXZ
// module chunks = 1